// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import * as types from './actionTypes';

export function requestConfirm(data) {
  return {
    type: types.CONFIRM_REQUEST,
    ...data
  };
}

export function confirmOrderForCharity(data) {
  return {
    type: types.CONFIRM_ORDER_FOR_CHARITY,
    ...data,
  };
}

export function requestConfirmFailed(data) {
  return {
    type: types.CONFIRM_REQUEST_FAILED,
    data,
  };
}

export function setMessage(data) {
  return {
    type: types.CONFIRM_SET_MESSAGE,
    data,
  };
}

export function setPaymentType(data) {
  return {
    type: types.SET_PAYMENT_TYPE,
    data,
  };
}

export function setIsCollectionArranged(payload) {
  return {
    type: types.SET_IS_COLLECTION_ARRANGED,
    payload,
  };
}

export function selectCharityId(charityId) {
  return {
    type: types.SELECT_CHARITY_ID,
    charityId,
  };
}

export function getCharities() {
  return {
    type: types.GET_CHARITIES,
  };
}

export function getCharitiesSuccess(charities) {
  return {
    type: types.GET_CHARITIES_SUCCESS,
    charities,
  };
}
